export class FlowPurchaseRequest {

  constructor(
    public PurchaseAll: boolean = false,
    public FlowOIDs: Array<number> = []
  ) {
  }

}
